import { UserVSQuestionInsert, UserVSQuestionInsertMany, UserVSQuestionDelete, UserVSQuestionUpdate, UserVSQuestionGetById, UserVSQuestionGetList, UserVSQuestionGetPageList } from "@/api/uservsquestion/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    UserVSQuestionInsert(context, payload) {
        return new Promise((resolve, reject) => {
            UserVSQuestionInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 新增
    UserVSQuestionInsertMany(context, payload) {
        return new Promise((resolve, reject) => {
            UserVSQuestionInsertMany(payload).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    UserVSQuestionUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            UserVSQuestionUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    UserVSQuestionGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            UserVSQuestionGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    UserVSQuestionGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            UserVSQuestionGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    UserVSQuestionGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            UserVSQuestionGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}